import './AdminDashboard.css';

function AdminDashboard({ user, onSelectMode }) {
  return (
    <div className="admin-dashboard-container">
      <div className="admin-dashboard-content">
        <h2>Admin Dashboard</h2>
        <p className="subtitle">Hallo! Was möchten Sie tun?</p>

        <div className="mode-grid">
          <div
            className="mode-card"
            onClick={() => onSelectMode('tools')}
          >
            <div className="mode-icon">🛠️</div>
            <h3>Tools nutzen</h3>
            <p>
              Greifen Sie auf verschiedene Tools zu
            </p>
            <button className="mode-button">Zu den Tools</button>
          </div>

          <div
            className="mode-card verwaltung-mode"
            onClick={() => onSelectMode('verwaltung')}
          >
            <div className="mode-icon">💼</div>
            <h3>Verwaltung</h3>
            <p>
              Stammdaten & Projekte verwalten
            </p>
            <button className="mode-button">Zur Verwaltung</button>
          </div>

          <div
            className="mode-card admin-mode"
            onClick={() => onSelectMode('admin')}
          >
            <div className="mode-icon">⚙️</div>
            <h3>Admin Panel</h3>
            <p>
              Mitarbeiter & Tools verwalten
            </p>
            <button className="mode-button">Zum Admin-Panel</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;